'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.createContainerComponent = createContainerComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _ = _interopRequireWildcard(_lodash);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _container = require('./container.cssm');

var _container2 = _interopRequireDefault(_container);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A standard container type from our Style Guide. Use the "type" prop to choose
 * which container type. The possible values are:
 *
 */
var Container = function (_Component) {
  _inherits(Container, _Component);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Container).apply(this, arguments));
  }

  _createClass(Container, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var type = _props.type;
      var className = _props.className;
      var variant = _props.variant;


      var classes = (0, _classnames2.default)(_container2.default[type + '-' + variant],
      // Add global (not-renamed by css-modules) CSS classes indicating:
      // 1. this text came from this Component ("ls-container"); and
      // 2. the style guide type of this container (e.g. "ls-container-cell" or
      //    "ls-container-dropdown").
      // This allows for overriding styles by type, either locally or globally.
      'ls-container', 'ls-container-' + type,
      // Any additional className passed in 'className' prop to this component
      className);

      return _react2.default.createElement(
        'div',
        { className: classes },
        children
      );
    }
  }]);

  return Container;
}(_react.Component);

Container.propTypes = {
  children: _react.PropTypes.any,
  type: _react.PropTypes.oneOf(['cell', 'card', 'dropdown', 'dialog', 'headerBar', 'sectionHeader']),
  variant: _react.PropTypes.string,
  className: _react.PropTypes.string
};
Container.defaultProps = {
  type: 'cell',
  variant: 'default'
};
exports.default = Container;
;

/**
 * Returns a Stateless Function Component that composes `<Container>`, binding a
 * specific `type` prop. For instance, createContainerComponent('cell') returns
 * a Component that composes `<Container type="cell">`
 */
function createContainerComponent(type) {
  var component = function component(props) {
    return _react2.default.createElement(Container, _extends({ type: type }, props));
  };
  // TODO: once we update to lodash 4, the capitalization behavior we want is
  // called `upperFirst`. Remove this conditional and just use _.upperFirst.
  var upperFirst = _.upperFirst || _.capitalize;
  component.displayName = upperFirst(type);
  return component;
}
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/@chartbeat/light-side/lib/components/container/container.js
// module id = 144
// module chunks = 0